const styles = (theme) => ({
  dialogStyle: {
    zIndex: '1200 !important',
  },

  grey: {
    color: theme.palette.greyScale[2],
  },
  okButton: {
    marginTop: 6,
    transition: 'opacity 1s ease 0.2s',
  },

  waitCenter: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '4px',
  },

  // CCPA data
  centerWrapper: {
    height: 350,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  nameRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    width: '100%',
  },
  nameField: {
    width: 280,
    marginRight: 24,
  },
  zipField: {
    width: 240,
  },
  explain: {
    ...theme.typography.subtitle2,
    color: theme.palette.greyScale[2],
    marginLeft: 6,
    fontWeight: 300,
  },
});

export default styles;
